export default __webpack_public_path__ + "static/social-thumbnail-ae7b05fa4e990a113e11554b7252bd84.png";